<template>
    <div class="mobile-entry-page">
        <!-- 顶部标题（设计图没有导航栏，直接居中标题） -->
        <div class="page-header">
            <h2 class="page-title">人员信息录入</h2>
            <p class="page-subtitle">请完成人脸与证件信息采集</p>
        </div>

        <!-- 页面主体内容 -->
        <div class="page-content">
            <!-- 1. 基本信息 -->
            <div class="section">
                <div class="section-title">
                    <span class="title-line"></span>
                    <span>基本信息</span>
                </div>
                <div class="field-item">
                    <label class="field-label">人员姓名</label>
                    <input v-model="form.name" type="text" class="field-input" placeholder="请输入真实姓名" />
                </div>
            </div>

            <!-- 2. 人脸照片 -->
            <div class="section">
                <div class="section-title">
                    <span class="title-line"></span>
                    <span>人脸照片</span>
                </div>
                <div class="upload-box" @click="chooseFacePhoto">
                    <div class="camera-icon">📸</div>
                    <p class="upload-text">点击拍摄或上传人脸照</p>
                    <p class="upload-tip">请正对镜头，光线充足</p>
                </div>
            </div>

            <!-- 3. 证件OCR识别 -->
            <div class="section">
                <div class="section-title">
                    <span class="title-line"></span>
                    <span>证件OCR识别</span>
                </div>

                <div class="id-type-wrap">
                    <button
                        v-for="item in idTypes"
                        :key="item.value"
                        :class="['id-type-btn', activeIdType === item.value ? 'active' : '']"
                        @click="activeIdType = item.value"
                    >
                        {{ item.label }}
                    </button>
                </div>

                <div class="upload-box" @click="scanIdCard">
                    <div class="file-icon">📄</div>
                    <p class="upload-text">拍摄证件照（自动OCR）</p>
                    <p class="upload-tip">请将证件放入框内，清晰无反光</p>
                </div>

                <div class="ocr-result">
                    <div class="ocr-title">
                        <span class="scan-icon">🔍</span>
                        <span>OCR识别结果（可修改）</span>
                    </div>
                    <div class="field-item">
                        <label class="field-label">证件姓名</label>
                        <input v-model="ocrResult.name" type="text" class="field-input" placeholder="识别的姓名信息" />
                    </div>
                    <div class="field-item">
                        <label class="field-label">证件号码</label>
                        <input v-model="ocrResult.idNo" type="text" class="field-input" placeholder="识别的身份证/卡号信息" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MobileEntry',
    data() {
        return {
            form: { name: '' },
            idTypes: [
                { label: '身份证', value: 'idCard' },
                { label: '老年卡', value: 'elderCard' },
                { label: '其他', value: 'other' }
            ],
            activeIdType: 'idCard',
            ocrResult: { name: '', idNo: '' }
        };
    },
    methods: {
        chooseFacePhoto() {
            this.$toast('打开相机/相册上传人脸照');
        },
        scanIdCard() {
            this.$toast('打开相机拍摄证件照');
            // 模拟OCR识别结果
            this.ocrResult.name = '张三';
            this.ocrResult.idNo = '110101199001011234';
        }
    }
};
</script>

<style scoped>
.mobile-entry-page {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding: 20px;
}

/* 顶部标题区 */
.page-header {
    text-align: center;
    margin-bottom: 24px;
}
.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 8px;
}
.page-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
}

/* 通用区块 */
.section {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 16px;
    overflow: hidden;
}
.section-title {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
}
.title-line {
    width: 3px;
    height: 16px;
    background-color: #1989fa;
    margin-right: 8px;
}

/* 输入项 */
.field-item {
    padding: 12px 16px;
}
.field-label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}
.field-input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box;
}
.field-input::placeholder {
    color: #bbb;
}

/* 上传虚线框 */
.upload-box {
    margin: 16px;
    padding: 32px 16px;
    border: 1px dashed #d0d5dd;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
}
.camera-icon,
.file-icon {
    font-size: 28px;
    margin-bottom: 12px;
}
.upload-text {
    font-size: 14px;
    color: #333;
    margin: 0 0 4px;
}
.upload-tip {
    font-size: 12px;
    color: #999;
    margin: 0;
}

/* 证件类型按钮 */
.id-type-wrap {
    display: flex;
    gap: 12px;
    padding: 16px;
}
.id-type-btn {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fff;
    font-size: 14px;
    color: #666;
    cursor: pointer;
}
.id-type-btn.active {
    background: #1989fa;
    color: #fff;
    border-color: #1989fa;
}

/* OCR结果区 */
.ocr-result {
    padding: 0 16px 16px;
}
.ocr-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    margin: 12px 0;
}
.scan-icon {
    margin-right: 6px;
}
</style>
